<template>
  <TitlePage
    class="page-edit-list"
    :title="lang.title"
    @back="$emit('back')"
    @commit="commit"
  >
    <div class="page-edit-list-container">
      <div v-for="(row, i) in input" :key="i" class="page-edit-list-sub">
        <div v-if="i!==0 && i!==input.length - 1" class="line"></div>
        <div v-if="row.type==='media'">
          <div>{{row.name}}</div>
          <div>{{row.value}}</div>
        </div>
        <div v-if="row.type==='qa'">
          <div>{{row.name}}</div>
          <div>{{row.value}}</div>
        </div>
        <div v-if="row.type==='range'" class="page-edit-list-range">
          <div class="page-edit-list-range-title">{{row.name}}</div>
          <BaseInput v-model.number="row.value[0]" type="number"></BaseInput>
          <span>到</span>
          <BaseInput v-model.number="row.value[1]" type="number"></BaseInput>
        </div>
        <div v-if="row.type==='tag'" class="page-edit-list-tag">
          <div class="page-edit-list-tag-title">{{row.name}}</div>
          <BaseButton4
            v-for="(refrow, refi) in config[row.ref]" :key="refi"
            :type="1"
            class="page-edit-list-tag-button"
            :data-active="row.value.indexOf(refrow.value) > -1"
            @click="toggleTag(refrow.value, refi, i)"
          >{{refrow.label}}</BaseButton4>
        </div>
      </div>
      <div style="height:50px;"></div>
    </div>
  </TitlePage>
</template>

<script>
import _ from 'lodash'

import TitlePage from './TitlePage.vue'

import { BaseButton4 } from '../button'
import { BaseInput } from '../input'

export default {
  components: {
    TitlePage,
    BaseButton4,
    BaseInput
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      lang: {
        title: `编辑${this.data.name}`
      },
      input: _.cloneDeep(this.data.value)
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    toggleTag (v, ii, i) {
      let inputIndex = this.input[i].value.indexOf(v)
      if (inputIndex > -1) {
        this.input[i].value.splice(inputIndex, 1)
      } else {
        this.input[i].value.push(v)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.page-edit-list {
  & .page-edit-list-container {
    position: absolute;
    overflow-y: auto;
    height: 100%;
    & .page-edit-list-sub {
      padding: 0 25px;
      & .line {
        height: 1px;
        border-bottom: 1px solid var(--colorDisabled);
      }
      & .page-edit-list-tag {
        padding: 10px 0;
        & .page-edit-list-tag-title {
          color: var(--colorGray0);
          margin: 7px;
        }
        & .page-edit-list-tag-button {
          margin: 7px;
          min-width: fit-content;
        }
      }
      & .page-edit-list-range {
        padding: 5px 0;
        & .page-edit-list-range-title {
          color: var(--colorGray0);
          margin: 7px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/EditListPage.vue